<template>
    <b-button 
        v-if="$temAcessoView('DESP-GERAIS-REQ-02') && permiteSolicitar"
        class="ml-2"
        variant="success"
        @click.stop="confirmarEnviar()"
    >
        <span>
            Solicitar Aprovação do {{ cargo }}
        </span>
    </b-button>
</template>

<script>
import DespesasServicos from './DespesasServicos'
import { StatusComprometimento } from '../../componentes/despesas/StatusComprometimento'
import { StatusDespesa } from '../../componentes/despesas/StatusDespesa'

export default {
    props: {
        despesa: {
            type: Object,
            default: () => null
        }
    },  

    methods: {
        confirmarEnviar() {
            this.$swal({
                title: 'Despesa',
                html: `Confirma o envio da despesa para aprovação do ${this.cargo} <strong>${this.despesa.nomeDemandante}</strong>?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.enviar()
                }
            })
        },

        enviar() {
            this.$store.dispatch('addRequest')
            DespesasServicos.solicitarAprovacao(this.despesa.despesaId).then(response => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Solicitação enviada com sucesso',
                            'OK',
                            this.$toastConfig.success
                        )
                        this.$emit('obterDespesa')
                    } else {
                        this.$toast.error(
                            response.errors[0],
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    },

    computed: {
        permiteSolicitar() {
            return this.despesa.codDemandante != null
                && this.despesa.statusComprometimentoId == StatusComprometimento.COMPROMETIDO
                && ( this.despesa.statusId == StatusDespesa.CRIADA
                    || this.despesa.statusId == StatusDespesa.REPROVADA_POR_DEMANDANTE
                    || this.despesa.statusId == StatusDespesa.REPROVADA_POR_GERENTE
                    || this.despesa.statusId == StatusDespesa.REPROVADA_PELA_UABS )
            },
        
            cargo() {
                if (this.despesa.alcadaGerencia
                    && this.despesa.codDemandante == this.despesa.codAutorizante) {
                        return 'gerente'
                } else {
                    return 'demandante'
                } 
            }
    }
}

</script>